import { render, staticRenderFns } from "./ColumnType.vue?vue&type=template&id=3f35fe04"
import script from "./ColumnType.vue?vue&type=script&lang=js"
export * from "./ColumnType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports